// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../../shared/core/constants/GAEventsConstants.mjs";
import * as FeaturedItemModuleScss from "../styles/FeaturedItem.module.scss";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";

var styles = FeaturedItemModuleScss;

function FeaturedItemCmp(Props) {
  var news_article = Props.news_article;
  var redirect_icon = Props.redirect_icon;
  var read_article_label = Props.read_article_label;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("div", {
              className: styles["featured-item-container"]
            }, React.createElement("div", {
                  className: styles.description
                }, news_article.content), React.createElement("div", {
                  className: styles.logo
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: news_article.publisher_logo.path,
                      height: 51.0,
                      width: 464.0,
                      quality: 100.0,
                      alt: news_article.publisher_logo.alt_text
                    })), React.createElement("a", {
                  className: styles["read-article-link"],
                  href: news_article.source.href,
                  rel: "noreferrer",
                  target: "_blank",
                  onClick: (function (param) {
                      PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, news_article.publisher_logo.alt_text + GAEventsConstants$PorterinFeature.gaReadArticleAction, news_article.source.href);
                    })
                }, React.createElement("div", {
                      className: styles["read-article-title"]
                    }, read_article_label), React.createElement("div", {
                      className: styles["read-article-outbound-logo"]
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: redirect_icon.path,
                          height: 20.0,
                          width: 20.0,
                          quality: 100.0,
                          alt: redirect_icon.alt_text
                        }))));
}

var make = FeaturedItemCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
